/**
 *
 * NOTE: Please maintain by alphabetical order; it will be easier to search and look through the file.
 * Add the values according to following labels
 *
 * 1. attributes - This will include site wide attributes values eg: (Email, Name, Password, etc);
 * 2. auth - This will include all the labels for the auth with nested objects;
 *         - Include all the translations inside respective object (eg: login, signUp, passwordReset, etc);
 * 3. common - This will include common translation in app eg: (Job, Candidate, Games, etc);
 * 4. label - This will include all the labels for the buttons eg: (Login, Sign Up, etc);
 * 5. message - This will include common messages that needs to be displayed in app eg: (Email verified, etc);
 * 6. modal - This will include all the labels, description, subheadings for the modal eg: (SignUp modal, Launch setup modal, etc);
 *
 *
 **/

const translation = {
  common: {
    yes: "Yes",
    no: "No",
  },
  fermentation: {
    sendToFermentation: "Are you sure you want to send to Fermentation?",
  },
  stripping: {
    addNewStrippingProcess:
      "Are you sure you want to start a new stripping process?",
    sendToStrippingProcess:
      "Are you sure you want to send to stripping process?",
    strippingSummary: "Stripping Summary",
  },
  spirit: {
    addSpiritProcess: "Are you sure you want to start a new spirit process?",
    sendToSpiritProcess: "Are you sure you want to send to spirit process?",
    spiritSummary: "Spirit Summary",
  },
  proofing: {
    sendToProofing: "Are you sure you want to send to Proofing?",
  },
};

export default { translation };
